var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRkn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 23.192V9.382h3.035v1.062c.76-.455 2.626-1.38 4.022-1.441 1.396-.061 2.96.936 3.566 1.441l-1.593 2.58c-.835-.404-2.793-1.092-3.946-.607-1.153.486-1.593 1.518-1.67 1.973v8.802H2zm14.873-4.704 3.263 3.49v-6.45c.278-.91 1.35-2.731 3.414-2.731 2.064 0 2.782 1.568 2.884 2.352v7.89H30c-.025-2.554-.121-8.012-.303-9.409-.228-1.744-2.429-4.02-5.009-4.02-2.064 0-4.047 1.113-4.78 1.67V9.61h-3.035v8.878zm-9.637 4.628v-9.712c.303-.279 1.108-.76 1.897-.456.789.304 1.593 1.139 1.897 1.518.683-.784 2.23-2.61 2.96-3.642.728-1.032 1.618-1.138 1.972-1.063v3.871l-2.2 2.354c1.315 1.517 4.097 4.704 4.704 5.311.607.607 1.214 1.467 1.442 1.822h-4.25L10.726 17.5v5.617h-3.49z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRkn);
export default __webpack_public_path__ + "static/media/RKN.14d8fdc3ab582a6dde6386cb533e46a2.svg";
export { ForwardRef as ReactComponent };